export const ProductTypes = {
  photos_with_me: "PhotosWithMe",
  photo: "Photo",
  frame: "Frame",
  promocode: "Promocode",
  photosWithFrame: "PhotosWithFrame",
  video: "FullVideo",
}